import { render, staticRenderFns } from "./TDSCheckbox.vue?vue&type=template&id=21f38183&scoped=true"
import script from "./TDSCheckbox.vue?vue&type=script&lang=ts"
export * from "./TDSCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./TDSCheckbox.vue?vue&type=style&index=0&id=21f38183&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f38183",
  null
  
)

export default component.exports